import React from 'react';

type IconProps = {
  size?: number; // Size of the icon
  className?: string; // Additional custom classes
};

const PerfumeIcon: React.FC<IconProps> = ({ size = 22, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.16604 5.49805V8.24919"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8345 5.49805V8.24919"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5856 19.2536H6.41515C5.40221 19.2536 4.58105 18.4325 4.58105 17.4195V10.0831C4.58105 9.07018 5.40221 8.24902 6.41515 8.24902H15.5856C16.5986 8.24902 17.4197 9.07018 17.4197 10.0831V17.4195C17.4197 18.4325 16.5986 19.2536 15.5856 19.2536Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="8.02002"
        y="2.74658"
        width="5.96082"
        height="2.75115"
        rx="0.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="7.79053"
        y="11"
        width="6.41934"
        height="5.50229"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PerfumeIcon;
